import * as $runtime from "../runtime.js";
import * as Control$dMonad$dReplace from "../Control.Monad.Replace/index.js";
import * as Data$dArray from "../Data.Array/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dTuple from "../Data.Tuple/index.js";
import * as Effect$dClass from "../Effect.Class/index.js";
import * as Foreign$dObject from "../Foreign.Object/index.js";
import * as Specular$dDom$dBrowser from "../Specular.Dom.Browser/index.js";
import * as Specular$dFRP$dWeakDynamic from "../Specular.FRP.WeakDynamic/index.js";
import * as Specular$dInternal$dEffect from "../Specular.Internal.Effect/index.js";
import * as Specular$dInternal$dRIO from "../Specular.Internal.RIO/index.js";
import * as Specular$dProfiling from "../Specular.Profiling/index.js";
const unBuilder = v => v;
const runBuilderWithUserEnv = userEnv => parent => v => () => {
  const actionsMutable = Specular$dInternal$dEffect.emptyDelayed();
  const result = Specular$dInternal$dRIO.runRIO({parent, cleanup: actionsMutable, userEnv})(v)();
  const actions = Specular$dInternal$dEffect.unsafeFreezeDelayed(actionsMutable)();
  return Data$dTuple.$Tuple(result, Specular$dInternal$dEffect.sequenceEffects(actions));
};
const runBuilder$p = (env, v) => v(env);
const runBuilder = /* #__PURE__ */ runBuilderWithUserEnv();
const monadEffectBuilder = Specular$dInternal$dRIO.monadEffectRIO;
const monadBuilder = Specular$dInternal$dRIO.monadRIO;
const mkBuilder$p = x => x;
const monadCleanupBuilder = {
  onCleanup: action => Specular$dInternal$dRIO.rio(env => Specular$dInternal$dEffect.pushDelayed(env.cleanup)(action)),
  Monad0: () => Specular$dInternal$dRIO.monadRIO
};
const local = fn => v => Specular$dInternal$dRIO.local(env => ({userEnv: fn(env.userEnv), cleanup: env.cleanup, parent: env.parent}))(v);
const getParentNode = /* #__PURE__ */ Specular$dInternal$dRIO.mapImpl(v => v.parent)(Specular$dInternal$dRIO.askImpl);
const functorBuilder = Specular$dInternal$dRIO.functorRIO;
const monadAskBuilder = {ask: /* #__PURE__ */ Specular$dInternal$dRIO.mapImpl(v => v.userEnv)(Specular$dInternal$dRIO.askImpl), Monad0: () => Specular$dInternal$dRIO.monadRIO};
const monadReaderBuilder = {local, MonadAsk0: () => monadAskBuilder};
const bindBuilder = Specular$dInternal$dRIO.bindRIO;
const applyBuilder = Specular$dInternal$dRIO.applyRIO;
const semigroupBuilder = dictSemigroup => (
  {
    append: (() => {
      const $0 = dictSemigroup.append;
      return a => b => Specular$dInternal$dRIO.applyImpl(Specular$dInternal$dRIO.mapImpl($0)(a))(b);
    })()
  }
);
const applicativeBuilder = Specular$dInternal$dRIO.applicativeRIO;
const monadDomBuilderBuilder = {
  text: str => Specular$dInternal$dRIO.rio(env => {
    const $0 = Specular$dDom$dBrowser.createTextNodeImpl(str);
    return () => {
      const node = $0();
      return Specular$dDom$dBrowser.appendChildImpl(node)(env.parent)();
    };
  }),
  dynText: dstr => Specular$dInternal$dRIO.bindImpl(Specular$dInternal$dRIO.rio(env => {
    const $0 = Specular$dDom$dBrowser.createTextNodeImpl("");
    return () => {
      const node = $0();
      Specular$dDom$dBrowser.appendChildImpl(node)(env.parent)();
      return node;
    };
  }))(node => Specular$dFRP$dWeakDynamic.subscribeWeakDyn_({MonadEffect0: () => Specular$dInternal$dRIO.monadEffectRIO, MonadCleanup1: () => monadCleanupBuilder})(Specular$dDom$dBrowser.setTextImpl(node))(dstr)),
  rawHtml: html => Specular$dInternal$dRIO.rio(env => Specular$dDom$dBrowser.appendRawHtmlImpl(html)(env.parent)),
  "elDynAttrNS'": namespace => tagName => dynAttrs => inner => Specular$dInternal$dRIO.bindImpl(Specular$dInternal$dRIO.askImpl)(env => Specular$dInternal$dRIO.bindImpl((() => {
    if (namespace.tag === "Just") { return Specular$dDom$dBrowser.createElementNSImpl(namespace._1)(tagName); }
    if (namespace.tag === "Nothing") { return Specular$dDom$dBrowser.createElementImpl(tagName); }
    $runtime.fail();
  })())(node => Specular$dInternal$dRIO.bindImpl(() => ({value: Foreign$dObject.empty}))(attrsRef => Specular$dInternal$dRIO.bindImpl(Specular$dFRP$dWeakDynamic.subscribeWeakDyn_({
    MonadEffect0: () => Specular$dInternal$dRIO.monadEffectRIO,
    MonadCleanup1: () => monadCleanupBuilder
  })(newAttrs => () => {
    const oldAttrs = attrsRef.value;
    attrsRef.value = newAttrs;
    Specular$dDom$dBrowser.removeAttributesImpl(node)(Data$dArray.filter(k => !Object.hasOwn(newAttrs, k))(Object.keys(oldAttrs)))();
    return Specular$dDom$dBrowser._setAttributes(
      node,
      Foreign$dObject.filterWithKey(k => v => {
        const $0 = Foreign$dObject._lookup(Data$dMaybe.Nothing, Data$dMaybe.Just, k, oldAttrs);
        if ($0.tag === "Nothing") { return true; }
        if ($0.tag === "Just") { return $0._1 !== v; }
        return true;
      })(newAttrs)
    );
  })(dynAttrs))(() => Specular$dInternal$dRIO.bindImpl(Specular$dInternal$dRIO.local(env$1 => ({parent: node, cleanup: env$1.cleanup, userEnv: env$1.userEnv}))(inner))(result => Specular$dInternal$dRIO.bindImpl(Specular$dDom$dBrowser.appendChildImpl(node)(env.parent))(() => Specular$dInternal$dRIO.pureImpl(Data$dTuple.$Tuple(
    node,
    result
  )))))))),
  elAttr: tagName => attrs => inner => Specular$dInternal$dRIO.bindImpl(Specular$dInternal$dRIO.askImpl)(env => Specular$dInternal$dRIO.bindImpl(Specular$dDom$dBrowser.createElementImpl(tagName))(node => Specular$dInternal$dRIO.bindImpl(() => Specular$dDom$dBrowser._setAttributes(
    node,
    attrs
  ))(() => Specular$dInternal$dRIO.bindImpl(Specular$dInternal$dRIO.local(env$1 => ({parent: node, cleanup: env$1.cleanup, userEnv: env$1.userEnv}))(inner))(result => Specular$dInternal$dRIO.bindImpl(Specular$dDom$dBrowser.appendChildImpl(node)(env.parent))(() => Specular$dInternal$dRIO.pureImpl(result)))))),
  liftBuilder: fn => fn,
  liftBuilderWithRun: fn => Specular$dInternal$dRIO.rio(env => () => fn(env, (env$p, v) => v(env$p))),
  Monad0: () => Specular$dInternal$dRIO.monadRIO
};
const monadReplaceBuilder$lazy = /* #__PURE__ */ $runtime.binding(() => (
  {
    newSlot: Specular$dInternal$dRIO.bindImpl(Specular$dInternal$dRIO.askImpl)(env => Specular$dInternal$dRIO.bindImpl(Specular$dDom$dBrowser.createTextNodeImpl(""))(placeholderBefore => Specular$dInternal$dRIO.bindImpl(Specular$dDom$dBrowser.createTextNodeImpl(""))(placeholderAfter => Specular$dInternal$dRIO.bindImpl(Specular$dDom$dBrowser.appendChildImpl(placeholderBefore)(env.parent))(() => Specular$dInternal$dRIO.bindImpl(Specular$dDom$dBrowser.appendChildImpl(placeholderAfter)(env.parent))(() => Specular$dInternal$dRIO.bindImpl(() => (
      {value: () => {}}
    ))(cleanupRef => {
      const $0 = Specular$dDom$dBrowser.removeAllBetweenImpl(placeholderBefore)(placeholderAfter);
      return Specular$dInternal$dRIO.bindImpl(Specular$dInternal$dRIO.rio(env$1 => Specular$dInternal$dEffect.pushDelayed(env$1.cleanup)(() => {
        const x = cleanupRef.value;
        return x();
      })))(() => Specular$dInternal$dRIO.pureImpl(Control$dMonad$dReplace.$Slot(
        inner => Specular$dProfiling.measure(Effect$dClass.monadEffectEffect)("slot replace")((() => {
          const $1 = Specular$dProfiling.measure(Effect$dClass.monadEffectEffect)("slot remove DOM")(Specular$dDom$dBrowser.removeAllBetweenImpl(placeholderBefore)(placeholderAfter));
          return () => {
            $1();
            const fragment = Specular$dDom$dBrowser.createDocumentFragmentImpl();
            const v = Specular$dProfiling.measure(Effect$dClass.monadEffectEffect)("slot init")(runBuilderWithUserEnv(env.userEnv)(fragment)(inner))();
            const x = cleanupRef.value;
            x();
            const m_parent = Specular$dDom$dBrowser.parentNode(placeholderAfter)();
            if (m_parent.tag === "Just") {
              Specular$dDom$dBrowser.insertBeforeImpl(fragment)(placeholderAfter)(m_parent._1)();
              cleanupRef.value = Specular$dProfiling.measure(Effect$dClass.monadEffectEffect)("slot cleanup")(() => {
                v._2();
                return cleanupRef.value = () => {};
              });
            } else if (m_parent.tag === "Nothing") {
              cleanupRef.value = v._2;
            } else {
              $runtime.fail();
            }
            return v._1;
          };
        })()),
        () => {
          $0();
          Specular$dDom$dBrowser.removeNode(placeholderBefore)();
          Specular$dDom$dBrowser.removeNode(placeholderAfter)();
          const x = cleanupRef.value;
          return x();
        },
        () => {
          const fragment = Specular$dDom$dBrowser.createDocumentFragmentImpl();
          const v = runBuilderWithUserEnv(env.userEnv)(fragment)(monadReplaceBuilder$lazy().newSlot)();
          const $1 = v._2;
          const $2 = cleanupRef.value;
          cleanupRef.value = () => {
            $2();
            return $1();
          };
          const m_parent = Specular$dDom$dBrowser.parentNode(placeholderAfter)();
          if (m_parent.tag === "Just") {
            Specular$dDom$dBrowser.insertBeforeImpl(fragment)(placeholderAfter)(m_parent._1)();
          } else if (m_parent.tag === "Nothing") {

          } else {
            $runtime.fail();
          }
          return v._1;
        }
      )));
    })))))),
    Monad0: () => Specular$dInternal$dRIO.monadRIO,
    MonadCleanup1: () => monadCleanupBuilder
  }
));
const monadReplaceBuilder = /* #__PURE__ */ monadReplaceBuilder$lazy();
const monoidBuilder = dictMonoid => (
  {
    mempty: Specular$dInternal$dRIO.pureImpl(dictMonoid.mempty),
    Semigroup0: () => (
      {
        append: (() => {
          const $0 = dictMonoid.Semigroup0().append;
          return a => b => Specular$dInternal$dRIO.applyImpl(Specular$dInternal$dRIO.mapImpl($0)(a))(b);
        })()
      }
    )
  }
);
export {
  applicativeBuilder,
  applyBuilder,
  bindBuilder,
  functorBuilder,
  getParentNode,
  local,
  mkBuilder$p,
  monadAskBuilder,
  monadBuilder,
  monadCleanupBuilder,
  monadDomBuilderBuilder,
  monadEffectBuilder,
  monadReaderBuilder,
  monadReplaceBuilder,
  monoidBuilder,
  runBuilder,
  runBuilder$p,
  runBuilderWithUserEnv,
  semigroupBuilder,
  unBuilder
};
